import React from "react";
import Sidebar from "./Sidebar/Sidebar.jsx";
import Footer from "./Footer";
import { ApplicationContextProvider } from "../context/ApplicationContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function Layout({ children, hideSidebar = false, hideFooter = false }) {
  return (
    <ApplicationContextProvider>
      <>
        <ToastContainer position="top-right" autoClose={1000} />
        <div className="flex min-h-screen font-Poppins">
          {!hideSidebar && <Sidebar />}
          <div className="flex flex-1 flex-col bg-slate-100 dark:bg-dark-bg">
            {children}
            {!hideFooter && <Footer />}
          </div>
        </div>
      </>
    </ApplicationContextProvider>
  );
}

export default Layout;
